import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
import { Condition } from '../types/budget';
interface ConditionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (note: string) => void;
  initialData?: Condition | null;
  contextName: string;
}
export function ConditionModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  contextName
}: ConditionModalProps) {
  const [note, setNote] = useState('');
  useEffect(() => {
    if (isOpen) {
      setNote(initialData?.note || '');
    }
  }, [isOpen, initialData]);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (note.trim()) {
      onSave(note);
      onClose();
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary/20 backdrop-blur-sm p-4" data-id="element-60">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden flex flex-col" data-id="element-61">
        <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-62">
          <h2 className="text-lg font-heading font-light text-primary" data-id="element-63">
            {initialData ? 'Edit Modification Request' : 'Add Modification Request'}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-primary transition-colors" aria-label="Close modal" data-id="element-64">
            <XIcon className="w-5 h-5" data-id="element-65" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 flex flex-col gap-4" data-id="element-66">
          <div data-id="element-67">
            <label className="block text-sm font-body font-thin text-gray-500 mb-1" data-id="element-68">
              Line Item
            </label>
            <div className="text-primary font-body font-normal bg-gray-50 p-2 rounded border border-gray-100" data-id="element-69">
              {contextName}
            </div>
          </div>

          <div data-id="element-70">
            <label htmlFor="note" className="block text-sm font-body font-thin text-gray-500 mb-1" data-id="element-71">
              Modification Note (For Borrower)
            </label>
            <textarea id="note" value={note} onChange={e => setNote(e.target.value)} className="w-full h-32 p-3 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-accent/50 font-body font-normal text-primary resize-none" placeholder="Describe what needs to be updated or clarified on this line item..." required data-id="element-72" />
          </div>

          <div className="flex justify-end gap-3 mt-4" data-id="element-73">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-body font-normal text-gray-600 hover:text-primary transition-colors" data-id="element-74">
              Cancel
            </button>
            <button type="submit" disabled={!note.trim()} className="px-4 py-2 text-sm font-body font-normal bg-accent text-white rounded-md hover:bg-accent/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-75">
              Save Modification
            </button>
          </div>
        </form>
      </div>
    </div>;
}